import { useState } from "react";
import { Box, Tabs, Tab, Container, Stack, Typography } from "@mui/material";

import Grades from "./hooks/grades";
import Sections from "./hooks/sections";
import { useI18n } from "i18n";

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const Page = (props: any) => {
  const [value, setValue] = useState(0);
  const { t } = useI18n();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
        <Stack direction="row" alignItems="center">
          <Typography
            variant="h1"
            gutterBottom
            sx={{ fontSize: "24px", fontWeight: "bold", mb: 4 }}
          >
            {t("gradeSections.title")}
          </Typography>
        </Stack>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="Grade/Section tabs selection"
          >
            <Tab label={t("field.grades")} {...a11yProps(0)} />
            <Tab label={t("field.sections")} {...a11yProps(1)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0}>
          <Grades />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <Sections />
        </CustomTabPanel>
      </Container>
    </>
  );
};

export default Page;
